import { StyleSheet } from 'react-native-web';
import { borderRadius, colors } from '../../global-styles';

const baseButtonStyles = {
  display: 'flex',
  justifyContent: 'center',
  borderRadius,
  borderWidth: 1,
  borderColor: colors.brandPrimary,
  backgroundColor: colors.brandPrimary,
  color: colors.white,
  paddingHorizontal: 12,
  paddingVertical: 12,
};

const baseTextStyles = {
  whiteSpace: 'nowrap',
};

const base = StyleSheet.create({
  baseStyles: {
    ...baseButtonStyles,
  },
  text: {
    ...baseTextStyles,
    textAlign: 'center',
    color: colors.white,
  },

  hover: {
    backgroundColor: colors.hover,
  },
  textHover: {
    color: colors.brandPrimary,
  },

  pressed: {},
  textPressed: {},

  circular: {
    width: 36,
    height: 36,
    borderRadius: 36,
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  thin: {
    height: 18,
  },
  full: {
    flex: 1,
  },
});

const outline = StyleSheet.create({
  // base
  baseStyles: {
    ...baseButtonStyles,
    backgroundColor: colors.white,
  },
  text: {
    ...baseTextStyles,
    color: colors.brandPrimary,
  },

  // hover states
  hover: {
    backgroundColor: colors.hover,
    borderColor: colors.brandPrimary,
  },
  textHover: {},

  // pressed states
  pressed: {
    backgroundColor: colors.brandPrimary,
  },
  textPressed: {
    color: colors.hover,
    fontWeight: 500,
  },
});

const link = StyleSheet.create({
  baseStyles: {
    ...baseButtonStyles,
    paddingHorizontal: 0,
    borderWidth: 0,
    backgroundColor: 'transparent',
  },
  text: {
    ...baseTextStyles,
    color: colors.brandPrimary,
  },

  hover: {
    borderWidth: 0,
    boxShadow: 0,
  },
  textHover: {
    color: colors.lightBlue,
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationColor: colors.lightBlue,
  },
});

const disabled = StyleSheet.create({
  baseStyles: {
    ...baseButtonStyles,
    backgroundColor: colors.lightGrey,
    borderWidth: 0,
  },
  text: {
    ...baseTextStyles,
    color: colors.mediumGrey,
  },
  hover: {
    cursor: 'not-allowed',
  },
});

export default {
  base,
  link,
  outline,
  disabled,
};
